// NPM MODULES
import React from 'react';
import {
  Button,
  Divider,
  Stack,
  InputLabel,
  TextField,
  Typography,
  Grid,
} from '@mui/material';

// I18N
import FindCustomerFormattedMessages from '../../../messages/admin/FindCustomerFormattedMessages';

const AdminSearch = ({ formData, setFormData, searchHandler }) => {
  const handleInputChange = (event) => {
    const { target } = event;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const name = target.name;

    setFormData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const submitHandler = (type) => {
    submitSearch(type);
  };

  const submitSearch = (type) => {
    if (type === 'ADMIN SEARCH - CUSTOMER') {
      console.log('search for a customer...');
      searchHandler(
        type,
        formData?.customer_id,
        formData?.customer_name,
        formData?.customer_domain,
        formData?.customer_auth,
        formData?.customer_ip_address
      );
    } else if (type === 'ADMIN SEARCH - USER') {
      console.log('search for a user...');
      searchHandler(
        type,
        formData?.user_id,
        formData?.user_name,
        formData?.user_email,
        formData?.user_phone
      );
    } else if (type === 'ADMIN SEARCH - ADMIN') {
      console.log('search for a admin...');
      searchHandler(type, formData?.admin_name, formData?.admin_email);
    } else if (type === 'ADMIN SEARCH - EMAIL ERROR') {
      console.log('search for a error email...');
      searchHandler(type, formData?.error_name, formData?.error_email);
    } else if (type === 'ADMIN SEARCH - MESSAGES VIA DESTINATION') {
      console.log('search for a destination message... ');
      searchHandler(type, formData?.destination_number);
    }
  };

  return (
    <Stack gap={3} sx={{ maxWidth: 800 }}>
      <Typography variant="h2">
        {FindCustomerFormattedMessages.searchForACustomer}
      </Typography>

      <Grid container spacing={2}>
        <Grid size={12}>
          <Stack
            sx={{
              flexDirection: { md: 'row' },
              alignItems: { md: 'center' },
              gap: { md: 2 },
            }}
          >
            <InputLabel sx={{ minWidth: 200 }}>
              {FindCustomerFormattedMessages.accountID}
            </InputLabel>

            <TextField
              type="text"
              name="customer_id"
              value={formData?.customer_id || ''}
              onChange={handleInputChange}
              variant="outlined"
              size="small"
              fullWidth
            />
          </Stack>
        </Grid>
        <Grid size={12}>
          <Stack
            sx={{
              flexDirection: { md: 'row' },
              alignItems: { md: 'center' },
              gap: { md: 2 },
            }}
          >
            <InputLabel sx={{ minWidth: 200 }}>
              {FindCustomerFormattedMessages.name}
            </InputLabel>

            <TextField
              type="text"
              name="customer_name"
              value={formData?.customer_name || ''}
              onChange={handleInputChange}
              variant="outlined"
              size="small"
              fullWidth
            />
          </Stack>
        </Grid>

        <Grid size={12}>
          <Stack
            sx={{
              flexDirection: { md: 'row' },
              alignItems: { md: 'center' },
              gap: { md: 2 },
            }}
          >
            <InputLabel sx={{ minWidth: 200 }}>
              {FindCustomerFormattedMessages.domain}
            </InputLabel>
            <TextField
              type="text"
              name="customer_domain"
              value={formData?.customer_domain || ''}
              onChange={handleInputChange}
              variant="outlined"
              size="small"
              fullWidth
            />
          </Stack>
        </Grid>
        <Grid size={12}>
          <Stack
            sx={{
              flexDirection: { md: 'row' },
              alignItems: { md: 'center' },
              gap: { md: 2 },
            }}
          >
            <InputLabel sx={{ minWidth: 200 }}>
              {FindCustomerFormattedMessages.authCode}
            </InputLabel>
            <TextField
              type="text"
              name="customer_auth"
              value={formData?.customer_auth || ''}
              onChange={handleInputChange}
              variant="outlined"
              size="small"
              fullWidth
            />
          </Stack>
        </Grid>
        <Grid size={12}>
          <Stack
            sx={{
              flexDirection: { md: 'row' },
              alignItems: { md: 'center' },
              gap: { md: 2 },
            }}
          >
            <InputLabel sx={{ minWidth: 200 }}>
              {FindCustomerFormattedMessages.ipAddress}
            </InputLabel>
            <TextField
              type="text"
              name="customer_ip_address"
              value={formData?.customer_ip_address || ''}
              onChange={handleInputChange}
              variant="outlined"
              size="small"
              fullWidth
            />
          </Stack>
        </Grid>
        <Grid size={12} textAlign="right">
          <Button
            variant="contained"
            color="secondary"
            onClick={() => submitHandler('ADMIN SEARCH - CUSTOMER')}
          >
            {FindCustomerFormattedMessages.find}
          </Button>
        </Grid>
      </Grid>
      <Divider />

      <Typography variant="h2">
        {FindCustomerFormattedMessages.searchForAUser}
      </Typography>

      <Grid container spacing={2}>
        <Grid size={12}>
          <Stack
            sx={{
              flexDirection: { md: 'row' },
              alignItems: { md: 'center' },
              gap: { md: 2 },
            }}
          >
            <InputLabel sx={{ minWidth: 200 }}>
              {FindCustomerFormattedMessages.userID}
            </InputLabel>
            <TextField
              type="text"
              name="user_id"
              value={formData?.user_id || ''}
              onChange={handleInputChange}
              variant="outlined"
              size="small"
              fullWidth
            />
          </Stack>
        </Grid>
        <Grid size={12}>
          <Stack
            sx={{
              flexDirection: { md: 'row' },
              alignItems: { md: 'center' },
              gap: { md: 2 },
            }}
          >
            <InputLabel sx={{ minWidth: 200 }}>
              {FindCustomerFormattedMessages.name}
            </InputLabel>
            <TextField
              type="text"
              name="user_name"
              value={formData?.user_name || ''}
              onChange={handleInputChange}
              variant="outlined"
              size="small"
              fullWidth
            />
          </Stack>
        </Grid>
        <Grid size={12}>
          <Stack
            sx={{
              flexDirection: { md: 'row' },
              alignItems: { md: 'center' },
              gap: { md: 2 },
            }}
          >
            <InputLabel sx={{ minWidth: 200 }}>
              {FindCustomerFormattedMessages.email}
            </InputLabel>
            <TextField
              type="text"
              name="user_email"
              value={formData?.user_email || ''}
              onChange={handleInputChange}
              variant="outlined"
              size="small"
              fullWidth
            />
          </Stack>
        </Grid>
        <Grid size={12}>
          <Stack
            sx={{
              flexDirection: { md: 'row' },
              alignItems: { md: 'center' },
              gap: { md: 2 },
            }}
          >
            <InputLabel sx={{ minWidth: 200 }}>
              {FindCustomerFormattedMessages.cell}
            </InputLabel>
            <TextField
              type="text"
              name="user_phone"
              value={formData?.user_phone || ''}
              onChange={handleInputChange}
              variant="outlined"
              size="small"
              fullWidth
            />
          </Stack>
        </Grid>
        <Grid size={12} textAlign="right">
          <Button
            variant="contained"
            color="secondary"
            onClick={() => submitHandler('ADMIN SEARCH - USER')}
          >
            {FindCustomerFormattedMessages.find}
          </Button>
        </Grid>
      </Grid>

      <Divider />

      <Typography variant="h2">
        {FindCustomerFormattedMessages.searchForAnAdmin}
      </Typography>
      <Grid container spacing={2}>
        <Grid size={12}>
          <Stack
            sx={{
              flexDirection: { md: 'row' },
              alignItems: { md: 'center' },
              gap: { md: 2 },
            }}
          >
            <InputLabel sx={{ minWidth: 200 }}>
              {FindCustomerFormattedMessages.name}
            </InputLabel>
            <TextField
              type="text"
              name="admin_name"
              value={formData?.admin_name || ''}
              onChange={handleInputChange}
              variant="outlined"
              size="small"
              fullWidth
            />
          </Stack>
        </Grid>
        <Grid size={12}>
          <Stack
            sx={{
              flexDirection: { md: 'row' },
              alignItems: { md: 'center' },
              gap: { md: 2 },
            }}
          >
            <InputLabel sx={{ minWidth: 200 }}>
              {FindCustomerFormattedMessages.email}
            </InputLabel>
            <TextField
              type="text"
              name="admin_email"
              value={formData?.admin_email || ''}
              onChange={handleInputChange}
              variant="outlined"
              size="small"
              fullWidth
            />
          </Stack>
        </Grid>
        <Grid size={12} textAlign="right">
          <Button
            variant="contained"
            color="secondary"
            onClick={() => submitHandler('ADMIN SEARCH - ADMIN')}
          >
            {FindCustomerFormattedMessages.find}
          </Button>
        </Grid>
      </Grid>

      <Divider />

      <Typography variant="h2">
        {FindCustomerFormattedMessages.findAnErrorByEmail}
      </Typography>

      <Grid container spacing={2}>
        <Grid size={12}>
          <Stack
            sx={{
              flexDirection: { md: 'row' },
              alignItems: { md: 'center' },
              gap: { md: 2 },
            }}
          >
            <InputLabel sx={{ minWidth: 200 }}>
              {FindCustomerFormattedMessages.email}
            </InputLabel>
            <TextField
              type="text"
              name="error_email"
              value={formData?.error_email || ''}
              onChange={handleInputChange}
              variant="outlined"
              size="small"
              fullWidth
            />
          </Stack>
        </Grid>
        <Grid size={12} textAlign="right">
          <Button
            variant="contained"
            color="secondary"
            onClick={() => submitHandler('ADMIN SEARCH - EMAIL ERROR')}
          >
            {FindCustomerFormattedMessages.find}
          </Button>
        </Grid>
      </Grid>

      <Divider />

      <Typography variant="h2">
        {FindCustomerFormattedMessages.findMessagesViaDestNum}
      </Typography>

      <Typography style={{ marginLeft: '50px' }}>
        <i>{FindCustomerFormattedMessages.needToIncludeCountryCodeAndCell}</i>
      </Typography>

      <Grid container spacing={2}>
        <Grid size={12}>
          <Stack
            sx={{
              flexDirection: { md: 'row' },
              alignItems: { md: 'center' },
              gap: { md: 2 },
            }}
          >
            <InputLabel sx={{ minWidth: 200 }}>
              {FindCustomerFormattedMessages.destNumb}
            </InputLabel>
            <TextField
              type="text"
              name="destination_number"
              value={formData?.destination_number || ''}
              onChange={handleInputChange}
              variant="outlined"
              size="small"
              fullWidth
            />
          </Stack>
        </Grid>
        <Grid size={12} textAlign="right">
          <Button
            variant="contained"
            color="secondary"
            onClick={() =>
              submitHandler('ADMIN SEARCH - MESSAGES VIA DESTINATION')
            }
          >
            {FindCustomerFormattedMessages.find}
          </Button>
        </Grid>
      </Grid>
    </Stack>
  );
};

export default AdminSearch;
